module.exports = __webpack_public_path__ + "static/img/female-3.e8c36668.png";